module.exports = __webpack_public_path__ + "img/fire-flame.bfd11df8.svg";